export enum LoadingTestIds {
    CONTAINER = "loader_container"
}